// components
import { Icon } from '@sdb/planning-ui';
import { Box } from '@mui/material';

// styles
import {
  EntityActionButton,
  SelectedEntityContainer
} from './SelectedEntity.styles';

// types
import { SelectedEntityProps } from './SelectedEntity.types';
import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { MrpEntityKey } from '../../EntitySection.types';

// hooks
import { useFormContext } from 'react-hook-form';

// utils
import { formatEntityDisplayLabel } from 'components/mrp/mrp.utils';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';

const SelectedEntity = ({
  planningEntityType,
  entityIndex = 0
}: SelectedEntityProps) => {
  'use memo';
  const { getValues, setValue } = useFormContext<AppointmentFormFieldData>();

  const fieldKey = `planEntities.${planningEntityType}` as MrpEntityKey;
  const entities = getValues(fieldKey);
  const entity = entities[entityIndex];

  const { calendarIdsPerEntityId, openCalendar, closeCalendar } =
    useCalendarStore(
      useShallow((state) => ({
        calendarIdsPerEntityId: state.calendarIdsPerEntityId,
        openCalendar: state.control.openCalendar,
        closeCalendar: state.control.closeCalendar
      }))
    );

  const openedInCalendarIds = calendarIdsPerEntityId[entity.entityId!] || [];

  const removeEntity = () => {
    const fields = getValues(fieldKey);
    const newFields = fields.filter((_, i) => i != entityIndex);

    openedInCalendarIds.forEach((id) => closeCalendar(id));

    setValue(fieldKey, newFields, { shouldValidate: true, shouldDirty: true });
  };

  const displayLabel = formatEntityDisplayLabel(entity.label, entity.number);

  return (
    <SelectedEntityContainer>
      {displayLabel}

      <Box>
        <EntityActionButton
          tabIndex={-1}
          disabled={openedInCalendarIds.length > 0}
          variant="text"
        >
          <Icon
            type="calendar-month"
            fontSize="inherit"
            onClick={() =>
              openCalendar([
                {
                  label: entity.label,
                  planningEntityIdentifier: entity
                }
              ])
            }
          />
        </EntityActionButton>

        <EntityActionButton variant="text" tabIndex={-1}>
          <Icon type="xmark" fontSize="inherit" onClick={removeEntity} />
        </EntityActionButton>
      </Box>
    </SelectedEntityContainer>
  );
};

export default SelectedEntity;
